<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate(dialogBoxCurrency)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="name" pInputText [min]="fields.name.min" [max]="fields.name.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
      </div>
    </div>
    
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.iso_code.nullable}">{{ fields.iso_code.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="iso_code" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.iso_code"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.simbol.nullable}">{{ fields.simbol.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="simbol" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.simbol"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.decimal.nullable}">{{ fields.decimal.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="number" formControlName="decimal" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.decimal"></app-validation-msg>
      </div> 
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{dialogBoxCurrency.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'currencyList.currency' |translate }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/currencies/currencyForm.html